// extracted by mini-css-extract-plugin
export default {"table-header":"header_table-header__Y0is5"};